









import { Component, Vue, Prop } from "vue-property-decorator";
import VStatus from "./VStatus.vue";
import State from "@/usecases/accounting/estimate-status";
import Translator from "@/usecases/accounting/estimate-status-translater";

@Component({
  components: {
    VStatus
  }
})
export default class EstimateStatus extends Vue {
  @Prop({ required: true }) status!: string;

  get text() {
    return Translator.toJp(this.status);
  }

  get variant() {
    return `estimate-${this.status}`;
  }

  get options() {
    return State.all().map(s => ({
      text: Translator.toJp(s),
      value: s
    }));
  }
}
